import { objectSpread2 as _objectSpread2 } from './_virtual/_rollupPluginBabelHelpers.mjs';
import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { SizeWrapper, TouchWrapper } from './styles/styledComponents.mjs';
import { jsx } from 'react/jsx-runtime';

var Svg18LinkG = /*#__PURE__*/React.memo(function (props) {
  useContext(ThemeContext);
  props.iconColor;
  var component = /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18"
  }, props), {}, {
    children: /*#__PURE__*/jsx("path", {
      fill: props.iconColor ? props.iconColor : "#010505",
      fillRule: "evenodd",
      d: "M10.818 7.108a.6.6 0 1 1-.854.843 1.81 1.81 0 0 0-2.419-.143l-.122.108-2.81 2.79a1.84 1.84 0 0 0 2.476 2.713l.123-.11.37-.36a.6.6 0 0 1 .908.779l-.07.082-.374.362a3.04 3.04 0 0 1-4.421-4.16l.133-.148 2.826-2.806a3.01 3.01 0 0 1 4.234.05m3.308-3.311c1.073 1.08 1.177 2.778.24 4.007l-.122.15-2.771 2.762a3.03 3.03 0 0 1-4.264 0 .6.6 0 1 1 .844-.852 1.83 1.83 0 0 0 2.452.112l.122-.111 2.739-2.726a1.84 1.84 0 0 0-2.447-2.71l-.131.1-.34.3a.6.6 0 0 1-.869-.82l.075-.08.348-.307a3.04 3.04 0 0 1 4.124.175"
    })
  }));
  if (props.size) {
    component = /*#__PURE__*/React.createElement(SizeWrapper, {
      size: props.size
    }, component);
  }
  if (props.touch) {
    component = /*#__PURE__*/React.createElement(TouchWrapper, {
      size: props.size,
      touch: props.touch
    }, component);
  }
  return component;
});
var Svg18LinkG$1 = Svg18LinkG;

export { Svg18LinkG$1 as default };
